"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONNECTED_AUTO_DISMISS_MS = exports.WEBRTC_CONNECTION_STATUS_CHANGED = exports.WEBRTC_STATE = void 0;
exports.WEBRTC_STATE = {
    IDLE: "idle",
    CONNECTING: "connecting",
    CONNECTED: "connected",
    ERROR: "error",
};
exports.WEBRTC_CONNECTION_STATUS_CHANGED = "WebRtcConnectionStatusChanged";
exports.CONNECTED_AUTO_DISMISS_MS = 1500;
class WebRtcConnectionStatus {
    constructor($rootScope, $log, $timeout) {
        this.$rootScope = $rootScope;
        this.$log = $log;
        this.$timeout = $timeout;
        this._status = exports.WEBRTC_STATE.IDLE;
        this._visible = false;
        this._dismissTimer = null;
    }
    getStatus() {
        return this._status;
    }
    isVisible() {
        return this._visible;
    }
    setConnecting() {
        this.update(exports.WEBRTC_STATE.CONNECTING, true);
    }
    setConnected() {
        this.update(exports.WEBRTC_STATE.CONNECTED, true);
        this._dismissTimer = this.$timeout(() => {
            this._dismissTimer = null;
            this._visible = false;
            this.notify();
        }, exports.CONNECTED_AUTO_DISMISS_MS);
    }
    setError() {
        this.update(exports.WEBRTC_STATE.ERROR, true);
    }
    reset() {
        this.update(exports.WEBRTC_STATE.IDLE, false);
    }
    update(status, visible) {
        this.cancelDismiss();
        this._status = status;
        this._visible = visible;
        this.$log.info(`WebRTC connection status: ${status} (visible=${visible})`);
        this.notify();
    }
    cancelDismiss() {
        if (this._dismissTimer !== null) {
            this.$timeout.cancel(this._dismissTimer);
            this._dismissTimer = null;
        }
    }
    notify() {
        this.$rootScope.$broadcast(exports.WEBRTC_CONNECTION_STATUS_CHANGED, this._status);
        if (!this.$rootScope.$$phase)
            this.$rootScope.$apply();
    }
}
exports.default = WebRtcConnectionStatus;
WebRtcConnectionStatus.$inject = ["$rootScope", "$log", "$timeout"];
